import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './MenuTitle.module.scss';

import { IMenuTitleProps } from './MenuTitle.d';

function MenuTitle({}: IMenuTitleProps) {
  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['title']}>
        <span className={Styles['bold']}>KICK</span>
        AVENEWS
      </p>
    </div>
  );
}

export default MenuTitle;
